import { defaultKeywords } from "../keywords";

export const seoContentMapEn = {
    '/': {
        title: "Rodin - Free AI 3D Model Generator from Images | Hyper3D",
            description: "Create stunning 3D models with AI in seconds. Generate 3D models from text or images easily and revolutionize your creative process today.",
            keywords: defaultKeywords,
            h1Text: "Rodin - Free AI 3D Model Generator with Text and Image",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin': {
        title: "Rodin - AI 3D Model Generator for Free | Hyper3D",
            description: "Create stunning 3D models with AI in seconds. Generate 3D models from text or images easily and revolutionize your creative process today!",
            keywords: defaultKeywords,
            h1Text: "Rodin - Free AI 3D Model Generator with Text and Image",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin/page': {
        title: "Rodin - AI 3D Model Generator",
            description: "Create stunning 3D models with AI in seconds. Generate 3D models from text or images easily and revolutionize your creative process today!",
            keywords: defaultKeywords,
            h1Text: "Rodin - Free AI 3D Model Generator with Text and Image",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
    },
    '/rodin/search': {
        title: "3D Models | Hyper3D",
            description: "Ready to view and free to download in fbx, obj, glb and usd. For games, VR/AR, video production, and 3D printing.",
            keywords: defaultKeywords,
            h1Text: "Rodin - Free AI 3D Model Generator with Text and Image",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
    },
    '/rodin/tab/story': {
        title: "Rodin - User Stories Collection | Hyper3D",
            description: "Explore a wide range of user stories and see how Rodin is transforming the creative process for artists and designers.",
            keywords: defaultKeywords,
            h1Text: "Rodin - Free AI 3D Model Generator with Text and Image",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/rodin/tab/story"
    },
    '/chatavatar': {
        title: "ChatAvatar - AI 3D Facial Assets Generator | Hyper3D",
            description: "ChatAvatar by Hyper3D creates production-ready, hyper-realistic 3D facial assets with PBR textures from text or images in minutes.",
            keywords: defaultKeywords,
            h1Text: "ChatAvatar - 3D Facial Assets Generator",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/imageto3d': {
        title: "ChatAvatar - AI 3D Facial Assets Generator | Hyper3D",
            description: "ChatAvatar by Deemos Hyper3D creates production-ready, hyper-realistic 3D facial assets with PBR textures from text or images in minutes.",
            keywords: defaultKeywords,
            h1Text: "ChatAvatar - 3D Facial Assets Generator",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/subscribe': {
        title: "Pricing | Hyper3D",
            description: "Subscribe to Hyper3D to get access to exclusive features and content.",
            keywords: defaultKeywords + "Subscription, Hyper3D, Premium, Features",
            h1Text: "Subscription - Hyper3D",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/subscribe"
    },
    '/api-dashboard': {
        title: "API Dashboard | Hyper3D",
            description: "Manage your Hyper3D API keys and monitor usage statistics.",
            keywords: defaultKeywords + "API, Dashboard, Hyper3D, API Keys, Usage",
            h1Text: "API Dashboard",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/api-dashboard"
    },
    '/user/login': {
        title: "Login | Hyper3D",
            description: "Access your Hyper3D account. Free to use. Easy to try. Just ask and Hyper3D can help with modeling, texturing and more.",
            keywords: defaultKeywords + "Login, Hyper3D, User, Account",
            h1Text: "Login",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/user/login"
    },
    '/signup': {
        title: "Sign Up | Hyper3D",
            description: "Create a new Hyper3D account. Free to use. Easy to try. Just ask and Hyper3D can help with modeling, texturing and more.",
            keywords: defaultKeywords + "Sign Up, Hyper3D, Register, Account",
            h1Text: "Sign Up",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/signup"
    },
    '/legal/privacy': {
        title: "Privacy Policy | Hyper3D",
            description: "Read Hyper3D privacy policy to understand how we handle your data.",
            keywords: defaultKeywords + "Privacy Policy, Hyper3D, Data Protection, Privacy",
            h1Text: "Privacy Policy",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/legal/privacy"
    },
    '/legal/terms': {
        title: "Terms of Service | Hyper3D",
            description: "Read Hyper3D terms and conditions. These terms govern the creation with Hyper3D Services.",
            keywords: defaultKeywords + "Terms of Service, Hyper3D, Terms, Conditions",
            h1Text: "Terms of Service",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/legal/terms"
    },
    '/product/faq': {
        title: "Frequently Asked Questions | Hyper3D",
            description: "Find answers to common questions about Hyper3D products and services.",
            keywords: defaultKeywords + "FAQ, Hyper3D, Questions, Answers, Help",
            h1Text: "Frequently Asked Questions",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/product/faq"
    },
    '/omnicraft': {
        title: "OmniCraft - 3D Toolbox | Hyper3D",
            description: "Omnicraft is a free online 3D modeling toolbox for 3D artists, game developers, designers and more.",
            keywords: defaultKeywords + "HDRI Generator, image generator, image creator, omnicraft",
            h1Text: "Create Your Own Virtual World from Image, Text and Imagination",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/omnicraft/"
    },
    '/omnicraft/hdri': {
        title: "HDRI Panorama Generator - Build Your Own Virtual World | Hyper3D",
            description: "Creating your own virtual world with our HDRI panorama generator in seconds. From image, text and imagination.",
            keywords: defaultKeywords + "HDRI Generator, image generator, image creator, panorama generator, skybox generator",
            h1Text: "Create Your Own Virtual World from Image, Text and Imagination",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/omnicraft/hdri"
    },
    '/omnicraft/formatcon': {
        title: "3D Format Converter - Free and Fully Offline | Hyper3D",
            description: "Just drag and drop your 3D model file to convert it to any popular format such as obj, fbx, gltf, glb and usd. Free to use and fully offline.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "Free, Secure and Fully Offline 3D Model Converter",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/omnicraft/formatcon"
    },
    '/omnicraft/mesh': {
        title: "3D Mesh Sculpting - Free and Fully Offline | Hyper3D",
            description: "3D mesh sculpting tool that support any popular format such as obj, fbx, 3ds, dxf, glb and usd. Free to use and fully offline.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "Free, Secure and Fully Offline 3D Model Converter",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/omnicraft/mesh"
    },
    '/omnicraft/search': {
        title: "Rodin Search - 3D Model Search Engine | Hyper3D",
            description: "3D search engine that quickly find 3D models from Sketchfab, Daz3D and Rodin with image, text or 3D model itself.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "Rodin Search - 3D Model Search Engine",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/omnicraft/search"
    },
    '/omnicraft/viewer': {
        title: "3D Model Viewer - Free and Fully Offline | Hyper3D",
            description: "3D model viewer that support any popular format, such as obj, fbx, stl, gltf, 3ds, dxf, ply, glb and usd.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "Free, Secure and Fully Offline 3D Model Viewer",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/omnicraft/viewer"
    },
    '/omnicraft/texture': {
        title: "3D Texture Generator - 3D Texture from Image | Hyper3D",
            description: "AI texture generator that allows everyone to bring models, games, AR/VR, and art to life with realistic textures from image.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "Free, Secure and Fully Offline 3D Texture Generator",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Revolutionize 3D Modeling with Rodin & ChatAvatar",
            canonicalUrl: "https://hyper3d.ai/omnicraft/texture"
    },
}